import { queryOptions, useQuery } from "@tanstack/react-query";

import { getDataFromResponse } from "~/api/axiosUtils.ts";
import {
	getAssignableOrdersForInvoice,
	getInvoiceRecipientSummary,
	indexProcessedInvoices,
	indexProjectsInvoices,
	showInvoice,
} from "~/modules/billing/api/processedInvoice/processedInvoiceApiDispatchers.ts";


export const INVOICES_BASE_QUERY_KEY = "invoices";

export const ALL_PROCESSED_INVOICES_QUERY_KEY = [INVOICES_BASE_QUERY_KEY, "all"];

export const useAllProcessedInvoices = () => useQuery({
		queryKey: ALL_PROCESSED_INVOICES_QUERY_KEY,
		queryFn: () => indexProcessedInvoices().then(getDataFromResponse),
	},
);

export const INVOICE_QUERY_KEY = (invoiceId: string) => [INVOICES_BASE_QUERY_KEY, { invoiceId }];

export const useInvoice = (invoiceId: string) => useQuery({
		queryKey: INVOICE_QUERY_KEY(invoiceId),
		queryFn: () => showInvoice({ invoiceId }).then(getDataFromResponse),
	},
);

export const PROJECTS_INVOICES_QUERY_KEY = (projectId: string) => [INVOICES_BASE_QUERY_KEY, { projectId }];

export const useProjectsInvoices = (projectId: string) => useQuery({
		queryKey: PROJECTS_INVOICES_QUERY_KEY(projectId),
		queryFn: () => indexProjectsInvoices(projectId).then(getDataFromResponse),
	},
);

export const ASSIGNABLE_ORDERS_FOR_INVOICE_QUERY_KEY = (invoiceId: string) => [INVOICES_BASE_QUERY_KEY, "assignable-orders", { invoiceId }];

export const useAssignableOrdersForInvoice = (invoiceId: string) => {
	return useQuery({
		queryKey: ASSIGNABLE_ORDERS_FOR_INVOICE_QUERY_KEY(invoiceId),
		queryFn: () => getAssignableOrdersForInvoice(invoiceId).then(getDataFromResponse),
		enabled: !!invoiceId,
	});
};

export const invoiceRecipientQuery = (invoiceId: string) => queryOptions({
	queryKey: ["invoice-recipient-summary", { invoiceId }],
	queryFn: () => getInvoiceRecipientSummary(invoiceId).then(getDataFromResponse),
	enabled: !!invoiceId,
});